import { VideoGridContainer } from './VideoGridContainer'
import { useMemo, useState, useContext } from 'external/react'
import { TeacherContext } from 'teacher/context'
import {styled} from 'external/material'

const StyledVideoContainer = styled('div')(videoStyles)

export default function CarruselVideos() {
  const context = useContext(TeacherContext)
  const {translate, profile, navigate} = context as any

  const isDreyfous = useMemo(() => /^dreyfous.*/.test(profile.domain), [profile.domain])
  const isDgenius = useMemo(() => profile.institution.project == 'dgenius', [profile.institution.project])
  const [search, setSearch] = useState<string | null>(null);

  return (
    <StyledVideoContainer className='main-video-container'>
      <div className='search-bar-container'>
        <input 
          onChange={(e) => setSearch(e.target.value)}
          className='search-bar'
          placeholder={translate('search')}
        />
      </div>
      <VideoGridContainer searchCriteria={search}/>
    </StyledVideoContainer>
  )
}

function videoStyles () {
  return {
    "&.main-video-container": {
      display: "flex",
      width: "100%",
      padding: "50px 190px",
      flexDirection: "column",
      gap: "16px",
      marginBottom: "10px",
    },

    "& .carousel-grid-container": {
      display: "grid",
      width: "100%",
      gridTemplateColumns: "repeat(auto-fill, minmax(250px, 1fr))",
      gap: "22px",
      boxSizing: "border-box",
      overflowY: "auto",
      paddingRight: "10px",
    },

    "& .search-bar-container": {
      display: "flex",
      width: "100%",
      height: "60px",
      backgroundColor: "white",
      boxSizing: "border-box",
      padding: "15px",
      borderRadius: "4px",
      border: "1px solid rgb(200, 200, 200)",
    },

    "& .search-bar": {
      height: "30px",
      width: "250px",
      borderRadius: "50px",
      border: "1px solid rgb(200, 200, 200)",
      paddingLeft: "10px",
    },

    "& .carousel-item": {
      width: "100%",
      borderRadius: "8px",
      cursor: "pointer",
      transition: "transform 0.2s",
      backgroundColor: "white",
      boxShadow: "rgba(0, 0, 0, 0.1) 0px 4px 6px -1px, rgba(0, 0, 0, 0.06) 0px 2px 4px -1px",
    },

    "& .carousel-item:hover": {
      transform: "scale(1.05)",
    },

    "& .carousel-item img": {
      width: "100%",
      borderTopRightRadius: "8px",
      borderTopLeftRadius: "8px",
      aspectRatio: "16/11",
      objectFit: "cover",
    },

    "& .video-title": {
      fontSize: "14px",
      marginTop: "6px",
      color: "#2c7cbd",
      padding: "16px",
      margin: 0,
      boxSizing: "border-box",
      width: "100%",
    },

    "& .video-description": {
      fontSize: "11px",
      padding: "0px 16px 16px 16px",
      margin: 0,
      boxSizing: "border-box",
      width: "100%",
    },

    "& .modal-overlay": {
      position: "fixed",
      inset: 0,
      background: "rgba(0, 0, 0, 0.75)",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      zIndex: 99999999,
    },

    "& .modal-content": {
      position: "relative",
      width: "90%",
      maxWidth: "800px",
      background: "#000",
      borderRadius: "10px",
      padding: "12px",
    },

    "& .modal-content iframe": {
      width: "100%",
      height: "450px",
      borderRadius: "6px",
    },

    "& .modal-content h3": {
      color: "white",
      marginTop: "10px",
      fontSize: "16px",
    },

    "& .close-button": {
      position: "absolute",
      top: "6px",
      right: "8px",
      background: "none",
      border: "none",
      color: "white",
      fontSize: "22px",
      cursor: "pointer",
    },
  }
}